import React from 'react';

import { Box } from '@vimeo/bokeh';

export const BlueHighlight = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box
      display="inline-block"
      background="linear-gradient(100deg,rgba(23,213,255,0)0.5%,rgba(23,213,255,0.2)2.4%,rgba(23,213,255,0.2)5.8%,rgba(23,213,255,0.2)5%,rgba(23,213,255,0.4)96%,rgba(23,213,255,0)98%),linear-gradient(183deg,rgba(23,213,255,0)0%,rgba(23,213,255,0.3)7.9%,rgba(23,213,255,0)15%),linear-gradient(104deg,rgba(23,213,255,0)90%,rgba(23,213,255,1.25)2.4%,rgba(23,213,255,1)5.8%,rgba(23,213,255,0.5)93%,rgba(23,213,255,0.7)96%,rgba(23,213,255,0)98%)"
      margin="0"
      border-radius="10px"
      padding="1px 5px 1px 2px"
    >
      {children}
    </Box>
  );
};
